var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close icon"),React.createElement("desc",{"key":1},"Close icon"),React.createElement("g",{"fill":"#313F65","fillRule":"evenodd","transform":"translate(1 1)","key":2},[React.createElement("polygon",{"points":"1.739 0 21.745 20.005 20.005 21.745 0 1.739","key":0}),React.createElement("polygon",{"points":"21.745 1.739 1.739 21.745 0 20.005 20.005 0","key":1})])]);
}

IconClose.displayName = "IconClose";

IconClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img"};

module.exports = IconClose;

IconClose.default = IconClose;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./app/javascript/images/icons/icon-close.svg
// module id = 466
// module chunks = 0 1 2